document.addEventListener("DOMContentLoaded", function () {
  // Expose a simple global to toggle scrollbar visibility by adding/removing .hide-scrollbar
  if (!window.toggleScrollbarVisibility) {
    window.toggleScrollbarVisibility = function(force) {
      const root = document.documentElement;
      const cls = 'show-scrollbar';
      if (force === true) { root.classList.add(cls); return; }
      if (force === false) { root.classList.remove(cls); return; }
      root.classList.toggle(cls);
    };
    // Hide by default (ensure class absent)
    document.documentElement.classList.remove('show-scrollbar');
  }

  document.querySelectorAll('.media-container').forEach(container => {
    const thumbnail = container.querySelector('.thumbnail');
    const video = container.querySelector('video');
    const playIcon = container.querySelector('.play-icon');

  if (!thumbnail || !video) return;

  // Add pointer cursor to signify interactivity when a video exists
  container.classList.add('cursor-pointer');

    // Track if thumbnail should stay hidden after first play
    let permanentlyHidden = false;

    // Helper to show the thumbnail and play icon (skipped if permanently hidden)
    function showThumbnail() {
      if (permanentlyHidden || container.dataset.permanentHidden === 'true') return; // Do not restore after first playback
      thumbnail.classList.remove('is-hidden');
      if (playIcon) playIcon.style.display = '';
    }

    // Helper to hide the thumbnail and play icon
    function hideThumbnail(permanent = false) {
      thumbnail.classList.add('is-hidden');
      if (playIcon) playIcon.style.display = 'none';
      if (permanent) {
        permanentlyHidden = true;
        container.dataset.permanentHidden = 'true';
      }
    }

    // Pause all other videos and show their thumbnails
    function pauseOtherVideos() {
      document.querySelectorAll('.media-container video').forEach(otherVideo => {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
          const otherContainer = otherVideo.closest('.media-container');
          const otherThumb = otherContainer.querySelector('.thumbnail');
          const otherPlayIcon = otherContainer.querySelector('.play-icon');
          // If that video had its thumbnail permanently hidden, keep it hidden so paused frame remains visible
          if (otherContainer.dataset.permanentHidden === 'true') {
            if (otherThumb) otherThumb.classList.add('is-hidden');
            if (otherPlayIcon) otherPlayIcon.style.display = 'none';
          } else {
            // Otherwise restore its thumbnail (legacy behavior)
            if (otherThumb) otherThumb.classList.remove('is-hidden');
            if (otherPlayIcon) otherPlayIcon.style.display = '';
          }
        }
      });
    }

    // Click handler
    container.addEventListener('click', function (e) {
      const clickedVideo = e.target === video;
      const clickedThumb = e.target === thumbnail;
      const clickedPlayIcon = playIcon && (e.target === playIcon || playIcon.contains(e.target));

      // Toggle pause when clicking directly on the playing video
      if (clickedVideo && !video.paused) {
        video.pause();
        // Only restore thumbnail if not permanently hidden
        if (!permanentlyHidden) showThumbnail();
        return;
      }

      // If clicking the video while it's paused (and thumbnail already hidden permanently), resume playback
      if (clickedVideo && video.paused) {
        pauseOtherVideos();
        hideThumbnail(true);
        video.play();
        return;
      }

      // Start playback when clicking thumbnail, play icon, or empty container area while paused
      if ((clickedThumb || clickedPlayIcon || (!clickedVideo && video.paused)) && video.paused) {
        pauseOtherVideos();
        // Any user start makes the hide permanent
        hideThumbnail(true);
        video.play();
        return;
      }
    });

    // Show thumbnail when video ends, pauses, or exits fullscreen (iOS)
    video.addEventListener('ended', () => { if (!permanentlyHidden) showThumbnail(); });
    video.addEventListener('pause', function () {
      if (!permanentlyHidden) setTimeout(showThumbnail, 100);
    });
    video.addEventListener('webkitendfullscreen', () => { if (!permanentlyHidden) showThumbnail(); });

    // Fallback for Chrome/iOS: listen for fullscreenchange on the document
    document.addEventListener('fullscreenchange', function () {
      // If no video is in fullscreen, show the thumbnail
      if (!document.fullscreenElement) {
        showThumbnail();
      }
    });

    // Initial state
  // Initial state (thumbnail visible until first play)
  showThumbnail();
    video.pause();
  });
});